import { render, staticRenderFns } from "./TerraIndexCodeConventions.vue?vue&type=template&id=007d32b6"
import script from "./TerraIndexCodeConventions.vue?vue&type=script&lang=js"
export * from "./TerraIndexCodeConventions.vue?vue&type=script&lang=js"
import style0 from "./TerraIndexCodeConventions.vue?vue&type=style&index=0&id=007d32b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports